import api from "services/api";

function authHeaders() {
  return {
    access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
  };
}

export async function fetchUnitsOverdueStatus(
  document: string,
  instanceId: string
) {
  return api.get(
    `industrial/customer/v1/units-status?document=${document}?&instance-id=${instanceId}`,
    { headers: authHeaders() }
  );
}

export async function fetchCustomerMe() {
  return api.get(`industrial/customer/v1/customers/me`, {
    headers: authHeaders(),
  });
}

export async function postSuspension(body: {
  customerSiteId: string;
  instanceId: string;
  contactIdSf: string | null;
  reason: string;
}) {
  return api.post(`industrial/case/v1/suspensions`, body, {
    headers: authHeaders(),
  });
}

export async function postReconnection(body: {
  document: string | null;
  trusted: boolean;
  unitInstanceId: string;
}) {
  return api.post(`industrial/case/v1/reconnections`, body, {
    headers: authHeaders(),
  });
}

export async function createEmailContact(
  userId: string,
  body: { contact: string; contactType: string; siteId: string | null }
) {
  return api.post(
    `industrial/customer/v1/users/${userId}/contacts`,
    body,
    { headers: authHeaders() }
  );
}

export async function postRegisterToken(
  userId: string,
  body: { contactId: string; tokenType: string }
) {
  return api.post(
    `industrial/customer/v1/users/${userId}/tokens`,
    body,
    { headers: authHeaders() }
  );
}

export async function postValidateToken(userId: string, token: string) {
  return api.post(
    `industrial/customer/v1/users/${userId}/validations`,
    { token },
    { headers: authHeaders() }
  );
}

export async function patchUnitDeliveryType(unitId: string) {
  return api.patch(
    `industrial/customer/v1/customers/me/units/${unitId}`,
    { deliveryType: "EMAIL" },
    { headers: authHeaders() }
  );
}

export async function fetchCustomerMeUnits() {
  return api.get(`industrial/customer/v1/customers/me/units`, {
    headers: authHeaders(),
  });
}

export async function fetchSuspensions(params: Record<string, string>) {
  return api.get(`industrial/case/v1/suspensions`, {
    headers: authHeaders(),
    params,
  });
}

export async function fetchReconnections(params: Record<string, string>) {
  return api.get(`industrial/case/v1/reconnections`, {
    headers: authHeaders(),
    params,
  });
}
